module.exports = __webpack_public_path__ + "img/pecannoten-chocolade-in-kom.efe2acc4.jpg";